import React from 'react';
import { Star, Crown, Handshake, Minus, ShieldAlert } from 'lucide-react';
import { getLoyaltyTier } from '../../data/clientLoyalty';

const ICONS = { ShieldAlert, Minus, Handshake, Star, Crown };

/**
 * Loyalty badge — compact (used on Market cards) or large (Client page).
 * Surfaces tier name + colour and (optionally) the numeric score.
 */
export default function LoyaltyBadge({ score, showScore = false, size = 'sm' }) {
  const tier = getLoyaltyTier(score);
  const Icon = ICONS[tier.icon] || Handshake;

  if (size === 'lg') {
    return (
      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-white text-xs font-bold shadow-md"
        style={{ background: tier.color }}
        data-testid="loyalty-badge"
      >
        <Icon className="w-3.5 h-3.5" />
        <span>{tier.label}</span>
        {showScore && <span className="font-mono opacity-90">{Math.round(score)}/100</span>}
      </div>
    );
  }

  // Compact variant — small pill for the market list
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider text-white"
      style={{ background: tier.color }}
      data-testid="loyalty-badge"
      title={`Loyauté : ${Math.round(score)}/100`}
    >
      <Icon className="w-3 h-3" />
      {tier.label}
    </span>
  );
}
